export const persianToEnglishDigits = (input: string) => {
    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
    const englishDigits = "0123456789";
    return input.replace(/[۰-۹]/g, (char) => englishDigits[persianDigits.indexOf(char)]);
};